import { makeStyles, fade } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: fade(theme.colors.red, 0.5),
    borderBottom: `2px solid ${theme.colors.red}`,
    position: 'relative',
    height: 0,
    opacity: 0.0,
    transition: 'all 0.75s ease',

    '&.visible': {
      padding: theme.spacing(2),
      height: 'auto',
      marginTop: 0,
      marginBottom: 0,
      opacity: 1.0,
    },
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  iconCol: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 7,
  },
  contentCol: {
    display: 'flex',
    flexDirection: 'column',
    padding: `0 ${theme.spacing(1)}px`,
  },
  textWrapper: {
    fontWeight: 'bold',
  },
  displayText: {
    height: (p) => (p.isMobile ? 80 : 37),
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
  },
  linkButton: {
    cursor: 'pointer',
    color: theme.colors.blue,
    marginLeft: theme.spacing(1),
  },
  buttonContainer: {
    paddingTop: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(4),
    },
  },
  button: {
    color: theme.colors.white,
    marginRight: theme.spacing(1),
  },
  dontNotify: {
    backgroundColor: theme.colors.grey,
    '&:hover': {
      backgroundColor: theme.colors.darkGrey,
    },
  },
  share: {
    backgroundColor: theme.colors.blue,
    '&:hover': {
      backgroundColor: theme.colors.darkBlue,
    },
  },
  notify: {
    backgroundColor: theme.colors.darkBlue,
    '&:hover': {
      backgroundColor: theme.colors.darkGrey,
    },
  },
  sentMessageText: {
    marginLeft: theme.spacing(1),
  },
  actionButton: {
    backgroundColor: theme.colors.darkGrey,
    color: theme.colors.white,
  },
}));

export default useStyles;
